"use client";

import Link from "next/link";
import ReactMarkdown from "react-markdown";
import FloatingBackLink from "@/components/FloatingBackLink";
import remarkGfm from "remark-gfm";
import { BlogPost } from "@/data/types";
import { useData, useLocalePath } from "@/i18n/LangContext";

export function BlogPostClient({ post, content }: { post: BlogPost; content: string }) {
  const { ui } = useData();
  const lp = useLocalePath();

  const formatDate = (iso: string) =>
    new Date(`${iso}T00:00:00`).toLocaleDateString(ui.dateLocale, { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div className="w-full max-w-3xl py-4 md:py-16">
      <FloatingBackLink href={lp('/blog')} label={ui.blog.backToOverview} />
      <Link href={lp('/blog')} className="page-back no-select">← {ui.blog.backToOverview}</Link>

      <header className="blog-article--header">
        <h1>{post.title}</h1>
        <div className="blog-card--meta">
          <time dateTime={post.date}>{formatDate(post.date)}</time>
          <span aria-hidden="true">·</span>
          <span>{ui.blog.readingTime.replace('{min}', String(post.readingMinutes))}</span>
        </div>
        <div className="blog-card--tags">
          {post.tags.map(tag => <span key={tag} className="blog-card--tag">{tag}</span>)}
        </div>
      </header>

      <article className="blog-article" data-cy="blog-article">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </article>

      <div className="blog-article--footer">
        <Link href={lp('/blog')} className="page-back no-select">← {ui.blog.backToOverview}</Link>
      </div>
    </div>
  );
}
